<template>
    <div>
        <Preloader :start="spin"/>
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head py-2">
                <p class="modal-card-title is-size-6">{{modalTitleText}}</p>
                <span v-if="missing_information_warning" class="mr-5" style="background-color:#da1414; color:#fff;border-radius:20px;padding:3px 16px 3px 3px;">
                    <i class="mdi mdi-minus-circle-outline pr-1 pl-1"></i>
                    {{$t('missing_information_in_the_record')}}
                </span>
                <span v-if="unregistered_records_warning" class="mr-5" style="background-color:#fdcc4a; color:#2c3a4b;border-radius:20px;padding:3px 16px 3px 3px;">
                    <i class="mdi mdi-alert-circle pr-1 pl-1"></i>
                    {{$t('unregistered_records')}}
                </span>
                <span v-if="transfer_error_warning" class="mr-5" style="background-color:#b95000; color:#fff;border-radius:20px;padding:3px 16px 3px 3px;">
                    <i class="mdi mdi-alert-circle pr-1 pl-1"></i>
                    {{$t('transfer_error_registration')}}
                </span>
                <button
                    type="button"
                    class="delete"
                    @click="confirmCloseUpsertModal()"/>
            </header>
            <section class="modal-card-body p-0">
                <div class="is-flex is-justify-content-left is-align-items-center p-5">
                    <h3 class="is-size-3 has-text-weight-medium mr-3">{{$t('recipient_information')}}</h3>
                    <b-tooltip class="custom-info-tooltip" position="is-bottom" multilined type="is-light" :triggers="['click']" :auto-close="['outside', 'escape']">
                        <b-icon type="is-default" icon="information"></b-icon>
                        <template v-slot:content>
                            <div v-html="$t('upser_modal_personal_info_tooltip')"></div>
                        </template>
                    </b-tooltip>
                </div>
                <div class="is-flex is-justify-content-left is-align-items-center has-border-bottom-light px-5 pb-5">
                    <b-field grouped>
                        <b-field :label="$t('recipient')" label-position="on-border">
                            <div class="input-with-buttons">
                                <TheMask v-if="isType=='number'" :disabled="isMode=='update'" class="input" v-model="recipient" mask="(###)#######" placeholder="(xxx)xxxxxxx" @input.native="setRecipientStatus()" @focus.native="showCheckRecipientButtons=true"></TheMask>
                                <b-input v-else-if="isType=='email'" :disabled="isMode=='update'" :class="{'email-input':isMode=='add'}" v-model="recipient" placeholder="xxxxxxxx@xxxx.xxx" @focus="showCheckRecipientButtons=true"></b-input>
                                <b-icon v-show="showCheckRecipientButtons" icon="check" type="is-success is-clickable" class="check-button" @click.native="checkRecipientF()"></b-icon>
                                <b-icon v-show="showCheckRecipientButtons" icon="close" type="is-danger is-clickable" @click.native="resetRecipientInput()" class="close-button"></b-icon>
                                <b-icon v-show="recipientIsAvailable&&!showCheckRecipientButtons&&isMode!=='update'" icon="pencil" type="is-clickable" @click.native="showCheckRecipientButtons=true" class="close-button"></b-icon>
                            </div>
                        </b-field>
                        <b-field :label="$t('name_surname')" label-position="on-border">
                            <div class="input-with-buttons">
                                <b-input :disabled="isNameInputPassive" v-model="name" @focus="showUpsertRecipientButtons=true"></b-input>
                                <b-icon v-show="showUpsertRecipientButtons" icon="check" type="is-success is-clickable" class="check-button" @click.native="upsertPersonF()"></b-icon>
                                <b-icon v-show="showUpsertRecipientButtons" icon="close" type="is-danger is-clickable" @click.native="resetNameInput()" class="close-button"></b-icon>
                                <b-icon v-show="recipientIsAvailable&&!showUpsertRecipientButtons" icon="pencil" type="is-clickable" @click.native="showUpsertRecipientButtons=true" class="close-button"></b-icon>
                            </div>
                        </b-field>
                    </b-field>
                </div>
                <div class="is-flex is-justify-content-space-between is-align-items-center p-5">
                    <div class="is-flex is-justify-content-left is-align-items-center">
                        <h3 class="is-size-3 has-text-weight-medium mr-3">{{$t('consent_information')}}</h3>
                        <b-tooltip class="custom-info-tooltip" position="is-bottom" multilined type="is-light" :triggers="['click']" :auto-close="['outside', 'escape']">
                            <b-icon type="is-default" icon="information"></b-icon>
                            <template v-slot:content>
                                <div v-html="$t('consent_info_tooltip')"></div>
                            </template>
                        </b-tooltip>
                    </div>
                    <b-button class="" :disabled="isAddConsentBtnPassive" type="is-primary" icon-left="plus" @click="addNewRowToConsentList()">{{$t('add_consent')}}</b-button>
                </div>
                <b-table
                :data="concat_records"
                checkable
                :checkedRows.sync="checkedRows"
                :header-checkable="true"
                @check-all="checkAll('isCheckedAllRows')"
                :is-row-checkable="(row) => (!row.hasIysRecord && row.sync_status=='awaiting_confirmation')"
                checkbox-position="left"
                bordered
                :sticky-header="true"
                class="custom-table manuel-upsert-table"
                :row-class="(row, index) => (row.target_update_iys_record_sid&&row.sync_status=='error_on_process' && 'is-ghost-row') || (row.sync_status==undefined && row.status == undefined && row.type == undefined && 'is-missing_info-row') || (row.sync_status=='confirmed' && 'is-ghost-row')"
                >
                <!-- row.sync_status == undefined && row.status == undefined && row.type == undefined -->
                    
                    <b-table-column field="brand_code" :label="$t('brand')" centered v-slot="props">
                        <div :class="{content:!isEditableCol(props.row,'brand_code')}">
                        <b-select v-model="updateObject.brand_code" v-if="isEditableCol(props.row,'brand_code')">
                            <option :value="brand.brand_code" v-for="(brand,bi) in brands" :key="bi">{{brand.name}}</option>
                        </b-select>
                        <div class="is-flex" v-else>
                            <b-tooltip v-if="getStatusIcon(props.row)!=false" class="custom-info-tooltip" position="is-right" multilined type="is-white" :triggers="['hover']" >
                                <img :src="getStatusIcon(props.row)" class="mr-2"/>
                                <template v-slot:content>
                                    <div class="is-flex">
                                        <b-icon :icon="getStatusIconInfo(props.row).icon" :type="getStatusIconInfo(props.row).type"></b-icon>
                                        <span class="pl-2" v-html="getStatusIconInfo(props.row).text"></span>
                                    </div>
                                </template>
                            </b-tooltip>
                            
                            <b-tooltip class="custom-info-tooltip" position="is-right" multilined type="is-light" :triggers="['hover']" >
                                
                                {{ getBrand(props.row) | shortName(8) }}
                                <template v-slot:content>
                                    <div v-html="getBrand(props.row)"></div>
                                </template>
                            </b-tooltip>
                            
                        </div>
                        </div>
                    </b-table-column>

                    <b-table-column field="type" :label="$t('consent_type')" centered v-slot="props">
                        
                        <b-select v-model="updateObject.type" v-if="isEditableCol(props.row,'type')">
                            <option v-for="(type,ti) in consentTypeListValue" :key="ti" :value="type.value">{{type.label}}</option>
                        </b-select>
                        <span v-else>
                            {{ consentTypeList[props.row.type] }}
                        </span>

                    </b-table-column>

                    <!-- İzin Durumu -->
                    <b-table-column field="status" :label="$t('consent_status')" centered v-slot="props">
                        <b-switch
                            v-if="isEditableCol(props.row,'status')"
                            v-model="updateObject.status"
                            true-value="ONAY"
                            false-value="RET"
                            passive-type='is-danger'
                            type='is-success'
                            :disabled="editRowSid=='NEWLINE' || props.row.sync_status=='awaiting_confirmation' || props.row.sync_status=='error_on_process'"
                            @input="resetEditRow(props.row.sid)"
                            >
                        </b-switch>
                        <span v-else class="status-tag" :class="getStatusClass(props.row)">
                            {{ getStatusText(props.row) }}
                        </span>
                    </b-table-column>



                    <b-table-column field="recipient_type" :label="$t('recipient_type')" centered >
                        <template v-slot:header="{ column }">
                            <b-tooltip class="custom-info-tooltip" position="is-bottom" multilined type="is-light"  >
                                {{ column.label }} <b-icon type="is-default" size="is-small" icon="information"></b-icon>
                                <template v-slot:content>
                                    <div>Tacir alıcı tipi için ilk girişte izin tarihi ve izin kaynağı alanlarının doldurulması zorunlu değildir.<br/>Tacir izinleri güncellenirken izin kaynağı ve tarihi girilmelidir.</div>
                                </template>
                            </b-tooltip>
                        </template>
                        <template centered v-slot="props">
                            <b-select v-model="updateObject.recipient_type"
                                v-if="isEditableCol(props.row,'recipient_type')"
                            >
                                <option value="BIREYSEL">{{$t('personal')}}</option>
                                <option value="TACIR">{{$t('commercial')}}</option>
                            </b-select>
                            <span v-else>
                                {{ recipientTypeList[props.row.recipient_type] }}
                            </span>
                        </template>
                            
                    </b-table-column>

                    <b-table-column field="source" :label="$t('consent_source')" centered >
                        <template v-slot:header="{ column }">
                            <b-tooltip class="custom-info-tooltip" position="is-bottom" multilined type="is-light"  >
                                {{ column.label }} <b-icon type="is-default" size="is-small" icon="information"></b-icon>
                                <template v-slot:content>
                                    <div> Karar seçeneği sadece izin durumu ret ise kullanılmalıdır.<br>2015 seçeneği seçili ise izin tarihi 01/05/2015 izin saati 00:00 gelmelidir.</div>
                                </template>
                            </b-tooltip>
                        </template>
                        <template centered v-slot="props">
                            <b-select v-model="updateObject.source"
                            v-if="isEditableCol(props.row,'source')">
                                <option :value="source.value" v-for="(source,si) in sourceList" :key="si" :disabled="source.disabled=='disabled'">{{source.label}}</option>
                            </b-select>
                            <span v-else>
                            {{ getSourceText(props.row) }}
                            </span>
                        </template>
                    </b-table-column>

                    <b-table-column field="consent_date" :label="$t('consent_date')" centered v-slot="props">
                        <div :class="{content:!isEditableCol(props.row,'consent_date')}">
                            <b-datetimepicker
                            :locale="$i18n.locale" 
                            v-model="updateObject.consent_date"
                            trap-focus
                            v-if="isEditableCol(props.row,'consent_date')"
                            :min-datetime="minimumDate"
                            :max-datetime="new Date()"
                            position="is-bottom-left"
                            horizontal-time-picker
                            >
                            </b-datetimepicker>
                            <div v-else>
                                <div class="has-text-right">{{ getConsentDate(props.row) }}</div>
                                <div class="has-text-right has-text-grey-light">{{ getConsentTime(props.row) }}</div>
                            </div>
                        </div>
                    </b-table-column>

                    <b-table-column field="retailer" :label="$t('vendors_of_origin')" centered v-slot="props">
                            <b-dropdown
                                append-to-body
                                aria-role="menu"
                                scrollable
                                max-height="200"
                                trap-focus
                                v-model="updateObject.retailer"
                                class="w-100"
                                expanded
                                v-if="isEditableCol(props.row,'retailer')"
                            >
                                <template #trigger class="w-100">
                                    <b-button class="has-text-left w-100 select">
                                        <b-tooltip class="custom-info-tooltip" position="is-left" multilined type="is-light" :triggers="['hover']" >
                                        <span>{{getVendorName(updateObject.retailer) | shortName(5)}}</span>
                                            <template v-slot:content>
                                                <div v-html="getVendorName(updateObject.retailer)"></div>
                                            </template>
                                        </b-tooltip>
                                    </b-button>
                                </template>

                                <b-dropdown-item custom aria-role="listitem">
                                    <b-input v-model="vendorFilterKey" :placeholder="$t('search')" expanded />
                                </b-dropdown-item>
                                <b-dropdown-item v-for="(vendor, vi) of filteredVendorList" :key="vi" aria-role="listitem" :value="vendor.iys_vendor_code">{{vendor.title}}</b-dropdown-item>
                            </b-dropdown>
                            
                            <b-tooltip v-else class="custom-info-tooltip" position="is-left" multilined type="is-light" :triggers="['hover']" >
                                {{ getRetailer(props.row) | shortName(14) }}
                                <template v-slot:content>
                                    <div v-html="getRetailer(props.row)"></div>
                                </template>
                            </b-tooltip>
                            
                    </b-table-column>

                    <!-- İzin Paylaşılan Bayi -->
                    <b-table-column field="retailer_access" :label="$t('vendors_with_consents')" centered v-slot="props">
                        <b-dropdown
                            append-to-body
                            aria-role="menu"
                            scrollable
                            max-height="200"
                            trap-focus
                            v-model="updateObject.retailer_access"
                            class="w-100"
                            expanded
                            multiple
                            v-if="isEditableCol(props.row,'retailer_access')"
                        >
                            <template #trigger class="w-100">
                                <b-button class="has-text-left w-100 select">
                                    <b-tooltip class="custom-info-tooltip" position="is-left" multilined type="is-light" :triggers="['hover']" >
                                        {{ getRetailerAccess(updateObject) | shortName(7) }}
                                        <template v-slot:content>
                                            <div v-html="getRetailerAccess(updateObject)"></div>
                                        </template>
                                    </b-tooltip>
                                </b-button>
                            </template>

                            <b-dropdown-item custom aria-role="listitem">
                                <b-input v-model="vendorFilterKey" :placeholder="$t('search')" expanded />
                            </b-dropdown-item>

                            <b-dropdown-item style="width: 225px;" v-for="(vendor, vi) of filteredVendorList" :key="vi" aria-role="listitem" @click.native="addOrRemoveRecord(vendor.iys_vendor_code, props.row.hasIysRecord)" :value="vendor.iys_vendor_code">

                                {{vendor.title}}

                            </b-dropdown-item>

                        </b-dropdown>

                        <b-tooltip v-else class="custom-info-tooltip" position="is-left" multilined type="is-light" :triggers="['hover']" >
                            {{ getRetailerAccess(props.row) | shortName(14) }}
                            <template v-slot:content>
                                <div v-html="getRetailerAccess(props.row)"></div>
                            </template>
                        </b-tooltip>

                    </b-table-column>
                    

                    <b-table-column field="" label="" centered v-slot="props">
                        
                        <div class="content">
                            <div v-if="editRowSid==props.row.sid">
                                <b-icon icon="check" type="is-success" class="is-clickable" @click.native="upsertRecordF()"></b-icon>
                                <b-icon icon="close" type="is-danger" class="is-clickable" @click.native="cancelUpsertRecord()"></b-icon>
                            </div>
                            
                            <div v-else-if="editRowSid==null" class="is-flex is-justify-content-center">
                                <b-icon icon="pencil" class="is-clickable edit-icon " @click.native="setEditRow(props.row)"></b-icon>

                                <b-icon v-if="isDeletableShow(props.row) && personChecker == 1" icon="delete-outline" style="color:#DA1414;" class="is-clickable edit-icon"  @click.native="deleteOnlyRecord(props.row.sid)"></b-icon>

                                <b-icon v-else-if="isDeletableShow(props.row) && personChecker != 1" icon="delete-outline" style="color:#DA1414;" class="is-clickable edit-icon" @click.native="deleteRecordF(props.row.sid)"></b-icon>

                                <b-icon v-if="isRestorableShow(props.row)" icon="history" style="color:#206DFF;" class="is-clickable edit-icon "  @click.native="restoreMetaRecordsF(props.row.sid)"></b-icon>
                            </div>

                        </div>
                    </b-table-column>
                   
                    
                    <template #empty>
                        <div>{{$t('no_result')}}</div>
                    </template>

                    <template #bottom-left>
                        
                    </template>
                </b-table>
            </section>
            <footer class="modal-card-foot is-flex is-justify-content-space-between">
                <b-notification
                    :closable="false"
                    type="is-warning is-light"
                    role="alert"
                    class="p-2 mb-1">
                    <b-icon icon="information" type="is-danger" size="is-small"></b-icon> 3 iş gününde aktarılmayan izinler geçersiz sayılacaktır.
                </b-notification>
                {{checkedRows.length}} Kayıt seçildi
                <div class="buttons">
                <b-button
                    :disabled="checkedRows.length==0"
                    label="Kayıtları e-devlet'e aktar"
                    type="is-primary"
                    @click="confirmMetaRecordsF()" />
                <b-button
                    outlined
                    label="Şimdi aktarma"
                    type="is-primary" 
                    @click="confirmCloseUpsertModal()"/>
                </div>
            </footer>
        </div>
    </div>
</template>
<script>
import {TheMask} from 'vue-the-mask'
import {mapActions,mapGetters} from 'vuex'
import Preloader from './Preloader'
export default {
    name:"UpsertConsent",
    props:['isMode','isType','personSid'],
    components: {
        TheMask,
        Preloader,
        },
    data() {
        return {
            person:{},
            missing_information_warning:false,
            unregistered_records_warning:false,
            transfer_error_warning:false,
            selectRow:[],
            minimumDate: new Date('2015-04-30T21:00:00.000Z'),
            recipientPrefix:"",
            recipientPostfix:"",
            recipient:"",
            name:"",
            editRowSid:null,
            concat_records:[],
            updateObject:{
                // "brand_code":null,
                 "status":'ONAY',
                // "type":null,
                // "consent_date":null
            },
            checkedRows:[],
           
            isCheckedAllRows:false,
            spin:false,
            vendorFilterKey : "",
            consentDataList:[],
            personRecordsData:[],
            showCheckRecipientButtons:false,
            showUpsertRecipientButtons:false,
            recipientIsAvailable:false,
            consentTypeList:{
                "ARAMA":this.$t('call'),
                "MESAJ": this.$t('text'),
                "EPOSTA":this.$t('email')
            },
            recipientTypeList:{
                "BIREYSEL":this.$t('personal'),
                "TACIR":this.$t('commercial')
            },
            consentStatusClassDict:{"ONAY":['tag','has-background-success-light','has-text-success'],"RET":['tag','has-background-danger-light','has-text-danger']},
            iconList:{"awaiting_confirmation":this.transferFailIconUrl,"error":this.needInfoIconUrl,"error_on_process":this.transferErrorIconUrl},
            transferErrorIconUrl:"/static/images/icons/transfer-error.svg",
            needInfoIconUrl:"/static/images/icons/need-info.svg",
            transferFailIconUrl:"/static/images/icons/transfer-fail.svg",
            transferOkIconUrl:"/static/images/icons/transfer-ok.svg",
            disabledIconUrl:"/static/images/icons/disabled.svg",
            deleteIconUrl:"/static/images/icons/delete.svg",
            sourceList:[
                {"value":"HS_2015", "label": this.$t("HS_2015")},
                {"value":"HS_KARAR", "label": this.$t("HS_KARAR")},
                {"value":"HS_FIZIKSEL_ORTAM", "label": this.$t("HS_FIZIKSEL_ORTAM")},
                {"value":"HS_ISLAK_IMZA", "label": this.$t("HS_ISLAK_IMZA")},
                {"value":"HS_ETKINLIK", "label": this.$t("HS_ETKINLIK")},
                {"value":"HS_ATM", "label": this.$t("HS_ATM")},
                {"value":"HS_EORTAM", "label": this.$t("HS_EORTAM")},
                {"value":"HS_WEB", "label": this.$t("HS_WEB")},
                {"value":"HS_MOBIL", "label": this.$t("HS_MOBIL")},
                {"value":"HS_MESAJ", "label": this.$t("HS_MESAJ")},
                {"value":"HS_EPOSTA", "label": this.$t("HS_EPOSTA")},
                {"value":"HS_CAGRI_MERKEZI", "label": this.$t("HS_CAGRI_MERKEZI")},
                {"value":"HS_SOSYAL_MEDYA", "label": this.$t("HS_SOSYAL_MEDYA")},
                {"value":"IYS_3338", "label": this.$t("IYS_3338"), "disabled":"disabled"},
                {"value":"IYS_CM", "label": this.$t("IYS_CM"), "disabled":"disabled"},
                {"value":"IYS_WEB", "label": this.$t("IYS_WEB"), "disabled":"disabled"},
                {"value":"IYS_MOBIL", "label": this.$t("IYS_MOBIL"), "disabled":"disabled"},
                {"value":"IYS_KISA_LINK", "label": this.$t("IYS_KISA_LINK"), "disabled":"disabled"}
            ],
            personChecker: null

        }
    },
    created(){
        
    },
    mounted(){

        if(this.isMode=='update'){
            this.setUpdateData()
        }
    },
    computed:{
        ...mapGetters(['brands','vendors']),
        modalTitleText(){
            if(this.isMode=='add'&&this.isType=='number'){
                return this.$t('add_new_call_or_text_consent_record')
            }else if(this.isMode=='add'&&this.isType=='email'){
                return this.$t('add_new_email_consent_record')
            }else if(this.isMode=='update'&&this.isType=='number'){
                return this.$t('record_details')
            }else if(this.isMode=='update'&&this.isType=='email'){
                return this.$t('record_details')
            }else{
                return ''
            }
        },
        consentData(){
            if(this.isMode=='add'){
                return this.consentDataList
            }else if(this.isMode=='update'){
                return this.concatPersonRecordsData
            }
            
        },
        isNameInputPassive(){
            if((!this.recipientIsAvailable||this.showCheckRecipientButtons)&&this.isMode=='add'){
                return true
            }
        },
        isAddConsentBtnPassive(){
            if(!this.recipientIsAvailable||this.editRowSid=='NEWLINE'){
                return true
            }
        },
        concatPersonRecordsData(){
            if(this.person.iys_records){
                let iysRecords = this.person.iys_records.map(obj=> ({ ...obj, hasIysRecord: true }))
                this.concat_records = iysRecords.concat(this.person.meta_records)
            }
            return this.concat_records
        },
        recipientFull(){
            if(this.isMode=='update'&&this.isType=='number'){
                return this.recipientPrefix + this.recipientPostfix
            }else if(this.isMode=='add'&&this.isType=='number'){
                return '+90' + this.recipientPostfix
            }else{
                return this.recipient
            }
        },
        filteredVendorList() {
            return this.vendors.filter((item) => (item.brand_code == this.updateObject.brand_code)&&(item.name.toLowerCase().indexOf(this.vendorFilterKey.toLowerCase()) >= 0));
        },
        sidValues(){
            return this.checkedRows.map(row => row.sid)
        },
        consentTypeListValue(){
            if(this.isType=='number'){
                return [{"value":"ARAMA", "label":this.$t('call')},{"value":"MESAJ", "label":this.$t('text')}]
            }else if(this.isType=='email'){
                return   [{"value":"EPOSTA", "label":this.$t('email')}]
            }
        },
        needMoreInfo(){
            if(this.updateObject.recipient_type==undefined){
                return true
            }
            else if(this.updateObject.recipient_type=='BIREYSEL'&&(
                this.updateObject.brand_code==undefined||
                this.updateObject.type==undefined||
                this.updateObject.status==undefined||
                this.updateObject.source==undefined||
                this.updateObject.consent_date==undefined
            )){
                return true
            }else if(this.updateObject.recipient_type=='TACIR'&&(
                this.updateObject.brand_code==undefined||
                this.updateObject.type==undefined||
                this.updateObject.status==undefined
            )){
                return true
            }else if((this.updateObject.recipient_type!=='BIREYSEL'&&this.updateObject.recipient_type!=='TACIR')&&(
                this.updateObject.brand_code==undefined||
                this.updateObject.type==undefined||
                this.updateObject.status==undefined||
                this.updateObject.recipient_type==undefined||
                this.updateObject.source==undefined||
                this.updateObject.consent_date==undefined
            )){
                return true
            }else{
                return false
            } 
        },

        hasSameRecord(){
            let sameRecord = false
            this.concat_records.some(row => {
                if(row.brand_code == this.updateObject.brand_code && row.type == this.updateObject.type && row.recipient_type == this.updateObject.recipient_type){
                    sameRecord=true
                }
            })
            return sameRecord
        }
    },

    methods:{
        ...mapActions(['getPersonByRecipient','getPerson','createPerson','updatePerson','insertRecord','updateRecord','confirmMetaRecords','deleteMetaRecords' ,'addRetailerAccess', 'removeRetailerAccess']),
        setEditRow(row){
            this.updateObject = {}
            if(row.sid=='NEWLINE'){
                this.updateObject.status='ONAY'
            }
            if(row.sid!=='NEWLINE'){
                for(var col in row){
                    if(['brand_code','type','status','recipient_type','source','consent_date','retailer','retailer_access'].includes(col)){
                        if(col=='consent_date'){
                            if(row[col]&&row[col].$date){
                                if(row.hasIysRecord){

                                    // this.updateObject.consent_date = row.consent_date.$date

                                    this.updateObject[col] = new Date(this.$moment(row[col].$date).format())

                                    this.minimumDate = new Date(this.$moment(row[col].$date).format())

                                }else{
                                    this.updateObject[col] = new Date(row[col].$date)
                                }
                            }
                        }else{
                            this.updateObject[col]=row[col]
                        }
                    }
                }        
            }
            this.editRowSid=row.sid
        },
        resetEditRow(sid){
            this.editRowSid=null
            this.editRowSid=sid
        },
        restoreMetaRecordsF(sid){
            this.$buefy.dialog.confirm({
                title: "Önceki Kayda Dönüş",
                message: "Seçtiğiniz izin kaydı gönderimden önceki versiyonuna geri alınacaktır.Böylece ilgili kaydı yeniden düzenlemeye başlayabilirsiniz.",
                type: 'is-danger',
                hasIcon: true,
                cancelText: this.$t('cancel'),
                confirmText: "Tamam",
                onConfirm: () => {
                    this.deleteMetaRecordsF(sid)
                    this.setUpdateData()
                }
            })
        },







        // silme işlemi bura
        deleteRecordF(sid){

            console.log(`sid => ${sid}`)
            
            this.$buefy.dialog.confirm({
                title: "Satır Siliniyor",
                message: "Oluşturduğunuz satır silinecektir. Emin misiniz?",
                type: 'is-danger',
                hasIcon: true,
                cancelText: this.$t('cancel'),
                confirmText: "Satırı Sil",
                onConfirm: () => {
                    this.deleteMetaRecordsF(sid)
                }
            })
            
        },


        deleteOnlyRecord(sid){

            console.log(`sid => ${sid}`)
            
            this.$buefy.dialog.confirm({
                title: "Satır Siliniyor",
                message: "Bu satırı silerseniz kayıt tamamen silinecektir. Emin misiniz?",
                type: 'is-danger',
                hasIcon: true,
                cancelText: this.$t('cancel'),
                confirmText: "Devam",
                onConfirm: () => {
                    this.deleteMetaRecordsF(sid)
                }
            })
            
        },











        upsertRecordF(){
          
                // const updateDate = this.$moment(this.updateObject.consent_date).format('MM/DD/YYYY HH:MM')
                // var parts = updateDate.match(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/);
                // var updateDates = Date.UTC(+parts[3], parts[2]-1, +parts[1], +parts[4], +parts[5]) ;
                // console.log('updateDates')
                // console.log(updateDates)


                // console.log('updateDate')
                // console.log(updateDate)

                // console.log('currentDate')
                // console.log(currentDate)
                    

                    // console.log('updateDate !== currentDate')
                    // console.log(updateDate.getTime() !== currentDate.getTime())

                    // console.log("row.consent_date.$date")
                    // console.log(row.consent_date.$date)
                    // console.log('this.updateObject.consent_date.getUTCMilliseconds()')
                    // console.log(typeof this.updateObject.consent_date)

                    

                    // console.log('Sırayla log atıyorum')

                    // console.log('brand_code')
                    // console.log(row.brand_code !=this.updateObject.brand_code)

                    // console.log('type')
                    // console.log(row.type != this.updateObject.type)

                    // console.log('status')
                    // console.log(row.status != this.updateObject.status)

                    // console.log('recipient_type)')
                    // console.log(row.recipient_type != this.updateObject.recipient_type)

                    // console.log('source')
                    // console.log(row.source != this.updateObject.source)

                
                    // Önemli
                    // console.log("rowDates")
                    // var rowDate = this.$moment(row.consent_date.$date).format('MM/DD/YYYY HH:MM')
                    // var parts = rowDate.match(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/);
                    // var rowDates = Date.UTC(+parts[3], parts[2]-1, +parts[1], +parts[4], +parts[5]) ;
                    // console.log(rowDates)
                    
                    // console.log('updateDates')
                    // const updateDate = this.$moment(this.updateObject.consent_date).format('MM/DD/YYYY HH:MM')
                    // var parts = updateDate.match(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/);
                    // var updateDates = Date.UTC(+parts[3], parts[2]-1, +parts[1], +parts[4], +parts[5]) ;
                    // console.log(updateDates)


                    // console.log('consent_date')
                    // console.log(this.updateObject.consent_date != row.consent_date.$date)


                    // console.log('retailer')
                    // console.log(row.retailer != this.updateObject.retailer)

                    // console.log('retailer_access')
                    // console.log(row.retailer_access != this.updateObject.retailer_access)


                    if(this.editRowSid!=='NEWLINE'&&this.editRowSid!==null){
                        console.log("updateObject update")
                        console.log(this.updateObject)
                        
                        this.updateObject.recipient = this.recipientFull
                        this.updateObject.sid = this.editRowSid
                        let row = this.concat_records.find(row => row.sid==this.editRowSid)

                        if(this.needMoreInfo){
                        this.$buefy.dialog.alert({
                            title: 'Eksik Veri Bulunuyor',
                            message: 'Oluşturduğunuz izinde eksik bilgiler mevcuttur. Eksik bilgilileri tamamlamadan devam edemezsiniz.',
                            type: 'is-warning',
                            hasIcon: true,
                            ariaRole: 'alertdialog',
                            ariaModal: true,
                            confirmText: 'Kaydı Düzenle'
                        })
                        return false
                    }
                    
                        if(row.hasIysRecord){

                            const updateDate1 = null;
                            const currentDate1 = null;

                            if(this.updateObject.consent_date){

                               this.updateDate1 = new Date(this.updateObject.consent_date)
                            }

                            if(row.consent_date){

                               this.currentDate1 = new Date(row.consent_date.$date)
                            }


                            if((row.brand_code != this.updateObject.brand_code || row.type != this.updateObject.type || row.status != this.updateObject.status || row.recipient_type != this.updateObject.recipient_type || row.source != this.updateObject.source || row.retailer != this.updateObject.retailer || row.retailer_access != this.updateObject.retailer_access)){

                                console.log('updateDate1')
                                console.log(this.updateDate1)
                                console.log('currentDate1')
                                console.log(this.currentDate1)

                                if(this.updateDate1.getTime() !== this.currentDate1.getTime()){


                            this.$buefy.dialog.confirm({
                                title: "İzin Aktarım Onayı",
                                message: "İzinlerinizi e-devlet paneline aktarmak üzeresiniz. Aktarım başladıktan sonra birçok izin bilgisini değiştirmeniz mümkün olmayacaktır. Onaylıyor musunuz?",
                                type: 'is-primary',
                                hasIcon: true,
                                cancelText: this.$t('cancel'),
                                confirmText: "İzinleri Aktar",
                                onConfirm: () => {
                                    this.updateRecord(this.updateObject).then((response) => {
                                        console.log('--updateRecord success response')
                                        console.log(response)
                                        let index = this.concat_records.findIndex(row => row.sid==this.editRowSid)
                                        if(index!='-1'){
                                            this.concat_records.splice(index,1,response.content.meta_record)
                                        }
                                        
                                        //this.concat_records.push(response.content.meta_record)
                                        this.cancelUpsertRecord()
                                    
                                    }).catch(e => {
                                        console.log('--updateRecord Error')
                                        console.log(e)
                                    })
                                }
                            })

                            }else{
                        this.$buefy.dialog.alert({
                            title: 'İzin Tarihi Güncellemek Zorunludur.',
                            message: 'İzinler güncellenirken mevcut izin tarih & saatinden, daha ileri bir tarih & saat girilmelidir.',
                            type: 'is-danger',
                            hasIcon: true,
                            ariaRole: 'alertdialog',
                            ariaModal: true,
                            confirmText: 'Kaydı Düzenle'
                        })
                        return false
                }
                    }else{
                        this.cancelUpsertRecord()
                    }

                        }else{
                            this.updateRecord(this.updateObject).then((response) => {
                                // console.log('--updateRecord success response')
                                // console.log(response)
                                let index = this.concat_records.findIndex(row => row.sid==this.editRowSid)
                                if(index!='-1'){
                                    this.concat_records.splice(index,1,response.content.meta_record)
                                }
                                //this.concat_records.push(response.content.meta_record)
                                this.cancelUpsertRecord()
                            
                            }).catch(e => {
                                // console.log('--updateRecord Error')
                                // console.log(e)
                            })
                        }

                        
                        
                    }else if(this.editRowSid=='NEWLINE'){
                        // console.log("updateObject insert")
                        // console.log(this.updateObject)
                        
                        if(this.hasSameRecord){
                            this.$buefy.dialog.alert({
                                title: 'Tekrarlanan Kayıt',
                                message: 'Aynı marka için aynı izin ve alıcı tipiyle izin kaydı oluşturulamaz. Lütfen kayıtlarınızı kontrol ediniz.',
                                type: 'is-warning',
                                hasIcon: true,
                                ariaRole: 'alertdialog',
                                ariaModal: true,
                                confirmText: 'Kaydı Düzenle'
                            })
                            
                            return false
                        }

                        if(this.needMoreInfo){
                        this.$buefy.dialog.alert({
                            title: 'Eksik Veri Bulunuyor',
                            message: 'Oluşturduğunuz izinde eksik bilgiler mevcuttur. Eksik bilgilileri tamamlamadan devam edemezsiniz.',
                            type: 'is-warning',
                            hasIcon: true,
                            ariaRole: 'alertdialog',
                            ariaModal: true,
                            confirmText: 'Kaydı Düzenle'
                        })
                        return false
                    }

                        //this.showUpsertRecipientButtons=false
                        this.updateObject.recipient = this.recipientFull

                        this.insertRecord(this.updateObject).then((response) => {
                            // console.log('--insertRecord success response')
                            // console.log(response)
                            this.concat_records.push(response.content.meta_record)
                            this.cancelUpsertRecord()
                        
                        }).catch(e => {
                            // console.log('--insertRecord Error')
                            // console.log(e)
                        })
                    }
                

              
                    // else{
                    //     this.$buefy.dialog.alert({
                    //             title: 'En Az Bir Alan Güncellemek Zorunludur.',
                    //             message: 'En Az Bir Alan Güncellemek Zorunludur.',
                    //             type: 'is-danger',
                    //             hasIcon: true,
                    //             ariaRole: 'alertdialog',
                    //             ariaModal: true,
                    //             confirmText: 'Kaydı Düzenle'
                    //         })
                    //         return false
                    // }
                    

            

        },


        cancelUpsertRecord(){
            if(this.editRowSid=='NEWLINE'){
                let indexOfEditLine = this.concat_records.findIndex(row => row.sid == 'NEWLINE')
                if(indexOfEditLine!="-1"){
                    this.concat_records.splice(indexOfEditLine,1)
                }
            }
            this.editRowSid = null
            this.updateObject = {}
            this.minimumDate = new Date('2015-04-30T21:00:00.000Z')
        },




        addOrRemoveRecord(data, hasIysRecord){
            if(hasIysRecord){
                if(this.updateObject.retailer_access.includes(data)){
                console.log('EKLE')

                let form = {}

                var retailerAccess = []

                retailerAccess.push(data)
                
                // form.type = this.updateObject.type
                // form.recipientType = this.updateObject.recipient_type
                // form.recipient = this.recipientFull
                form.sid = this.editRowSid
                form.retailerAccess = retailerAccess 
                
                console.log('Form nesnesi oluş')
                console.log(form)

                this.addRetailerAccess(form).then((response) => {
                    console.log('--addRetailerAccess success response')
                    console.log(response)
                
                }).catch(e => {
                    console.log('--addRetailerAccess Error')
                    console.log(e)
                })
                }else{
                    console.log('SİL')
                    
                    let form = {}

                   
                    var retailerAccess = []

                    retailerAccess.push(data)
                    
                    // form.type = this.updateObject.type
                    // form.recipientType = this.updateObject.recipient_type
                    // form.recipient = this.recipientFull
                    form.sid = this.editRowSid
                    form.retailerAccess = retailerAccess 
                    
                    console.log('Form nesnesi oluş')
                    console.log(form)

                    this.removeRetailerAccess(form).then((response) => {
                        console.log('--removeRetailerAccess success response')
                        console.log(response)
                    
                    }).catch(e => {
                        console.log('--removeRetailerAccess Error')
                        console.log(e)
                    })
                    

                }  
            }else{
                // console.log('addOrRemoveRecord not working')
            }

        },

        deleteMetaRecordsF(sid){
            let form = {}
            var sid_values =[]
            sid_values.push(sid)
            form.sid_values = sid_values        
            console.log('Form nesnesi oluş')
                    console.log(form)

                    this.deleteMetaRecords(form).then((response) => {
                        console.log('--deleteMetaRecords success response')
                        console.log(response)
                        if(response.status.code =="0"){
                            this.checkedRows=[]
                            this.setUpdateData()
                        }
                    
                    }).catch(e => {
                        console.log('--deleteMetaRecords Error')
                        console.log(e)
                    })
        },

        isEditableCol(row,col){
            let editableRow = false
            let editableCol = false
            if(row.sid==this.editRowSid&&this.editRowSid=='NEWLINE'){
                editableCol = true
                editableRow = true
                
            }else if(row.sid==this.editRowSid){
                editableRow = true
            }
            
            if(row.target_update_iys_record_sid&&row.sync_status!=='confirmed'&&!['brand_code','type','status','recipient_type','recipient','retailer',].includes(col)){

               editableCol = true
            }else if((row.hasIysRecord==true&&this.updateObject.status!=row.status&&!['brand_code','type','recipient_type','recipient','retailer'].includes(col))){
                editableCol = true
            }else if((row.hasIysRecord==true&&!['brand_code','type','recipient_type','recipient','retailer','consent_date','source'].includes(col))||(row.hasIysRecord!==true&&!row.target_update_iys_record_sid)){

                editableCol = true
                
            }else{
                editableCol = false
            }

            if(editableRow&&editableCol){
                
                return true
            }else{
                return false
            }
        },
        upsertPersonF(){
            if(this.recipientIsAvailable&&this.personSid){
                this.showUpsertRecipientButtons=false
                const form = {}
                form.sid = this.personSid
                form.name = this.name
                this.updatePerson(form).then((response) => {
                    // console.log('--updatePerson success response')
                    // console.log(response)
                
                }).catch(e => {
                    // console.log('--updatePerson Error')
                    // console.log(e)
                })
                
            }else if(this.recipientIsAvailable){
                
                this.showUpsertRecipientButtons=false
                const form = {}
                form.recipient = this.recipientFull
                form.name = this.name
                this.createPerson(form).then((response) => {
                    // console.log('--createPerson success response')
                    // console.log(response)
                    this.returnToEditMode(response.content.person.sid)
                
                }).catch(e => {
                    // console.log('--createPerson Error')
                    console.log(e)
                })
            }
        },

        confirmMetaRecordsF(){
            this.$buefy.dialog.confirm({
                title: "İzin Aktarım Onayı",
                message: "İzinlerinizi e-devlet paneline aktarmak üzeresiniz. Aktarım başladıktan sonra birçok izin bilgisini değiştirmeniz mümkün olmayacaktır. Onaylıyor musunuz?",
                type: 'is-primary',
                hasIcon: true,
                cancelText: this.$t('cancel'),
                confirmText: "İzinleri Aktar",
                onConfirm: () => {
                    let form={}
                    form.sid_values = this.sidValues
                    // console.log("form")
                    // console.log(form)

                    this.confirmMetaRecords(form).then((response) => {
                        // console.log('--confirmMetaRecords success response')
                        console.log(response)
                        this.$buefy.dialog.confirm({
                            title: "Aktarım Başladı",
                            message: "İzinlerin listenizde görünmesi kısa bir süre alabilir.",
                            type: 'is-success',
                            hasIcon: true,
                            canCancel:false,
                            confirmText: "Tamam",
                            onConfirm: () => {
                             this.$emit('close')
                            }
                        })
                    }).catch(e => {
                        // console.log('--confirmMetaRecords Error')
                        console.log(e)
                    })
                }
            })
            
        },
        confirmCloseUpsertModal(){
            let hasNotTransferedConsents = false
            this.concat_records.some(row => {
                if(row.sync_status == 'awaiting_confirmation'){
                    hasNotTransferedConsents=true
                }
            })

            if(hasNotTransferedConsents){
                this.$buefy.dialog.confirm({
                    title: "Aktarım Yapılmayacak",
                    message: "İzinleri aktarmama kararı aldınız. Alındığı tarihten sonra 3 iş gününde aktarılmayan izinler geçersiz sayılacaktır. En kısa sürede izinlerinizi aktarın.",
                    type: 'is-warning',
                    hasIcon: true,
                    cancelText: this.$t('cancel'),
                    confirmText: "Kaydet ve Devam Et",
                    onConfirm: () => {
                        this.$emit('close')
                    }
                })
            }else{
                this.$emit('close')
            }
        },
        setUpdateData(){
           
            this.missing_information_warning=false
            this.unregistered_records_warning=false
            this.transfer_error_warning=false
            if(this.personSid){
                this.showCheckRecipientButtons=false
                this.isDeletable=false
                this.isRestorable=false
                this.spin=true
                const form = {}
                form.personSid = this.personSid
                this.getPerson(form).then((response) => {
                    console.log('--getPerson success response')
                    console.log(response)
                    this.personChecker = response.content.person.meta_records.length
                    console.log(`personChecker => ${this.personChecker}`)
                    this.spin=false
                    this.person = response.content.person
                    if(this.person.iys_records){
                        let iysRecords = this.person.iys_records.map(obj=> ({ ...obj, hasIysRecord: true }))
                        let old_iys_records = this.person.meta_records.filter(row => row.target_update_iys_record_sid).map(obj=> obj.target_update_iys_record_sid)
                        this.concat_records = iysRecords.concat(this.person.meta_records).filter(row => !old_iys_records.includes(row.sid))
                    }
                    this.name = this.person.name
                    if(this.isType=='number'){
                        this.recipientPrefix = this.person.recipient.substr(0,this.person.recipient.length - 10)
                        this.recipientPostfix = this.person.recipient.substr(this.person.recipient.length - 10)
                        this.recipient = this.recipientPostfix
                    }else{
                        this.recipient = this.person.recipient
                    }
                    this.personRecordsData=this.person
                    this.recipientIsAvailable=true
                   
                    console.log("--------------this.recipientIsAvailable---")
                    console.log(this.recipientIsAvailable)
                    console.log("concat records");
                    console.log(this.concat_records);
                    console.log("getperson");
                    console.log(response);
                    // :row-class="(row, index) => row.target_update_iys_record_sid&&row.sync_status!=='error_on_process' && 'is-ghost-row'"
                    // row.sync_status == undefined && row.status == undefined && row.type == undefined
                    for(var i=0;i<this.concat_records.length;i++){
                        if(this.concat_records[i].sync_status=='awaiting_confirmation' && this.concat_records[i].sync_status=='error_on_process'&& (this.concat_records[i].sync_status==undefined && this.concat_records[i].status == undefined && this.concat_records[i].type == undefined)){
                            this.missing_information_warning=true
                            this.unregistered_records_warning=true
                            this.transfer_error_warning=true
                        }
                        else if(this.concat_records[i].sync_status=='awaiting_confirmation' && this.concat_records[i].sync_status=='error_on_process'){
                            this.unregistered_records_warning=true
                            this.transfer_error_warning=true
                        }
                        else if(this.concat_records[i].sync_status=='awaiting_confirmation' && (this.concat_records[i].sync_status==undefined && this.concat_records[i].status == undefined && this.concat_records[i].type == undefined)){
                            this.unregistered_records_warning=true
                            this.missing_information_warning=true
                        }
                        else if(this.concat_records[i].sync_status=='error_on_process' && (this.concat_records[i].sync_status==undefined && this.concat_records[i].status == undefined && this.concat_records[i].type == undefined)){
                            this.transfer_error_warning=true
                            this.missing_information_warning=true
                        }
                        else if(this.concat_records[i].sync_status=='error_on_process'){
                            this.transfer_error_warning=true
                        }
                        else if(this.concat_records[i].sync_status=='awaiting_confirmation'){
                            this.unregistered_records_warning=true
                            //   this.selectRow = this.concat_records.findIndex(row => row.sync_status=='awaiting_confirmation')
                            // console.log(this.selectRow);
                        }
                        else if((this.concat_records[i].sync_status==undefined && this.concat_records[i].status == undefined && this.concat_records[i].type == undefined)){
                            this.missing_information_warning=true
                        }
                        else{

                        }
                    }
                    
                
                }).catch(e => {
                    this.spin=false
                    console.log('--getPerson Error')
                    console.log(e)
                })
                
            }
        },
        checkRecipientF(){
            console.log(this.isValidateEmail(this.recipientFull))
            console.log(this.isType=='email')
            this.spin=true
            if(this.recipientFull.length<13&&this.isType=='number'){
                this.$buefy.dialog.alert({
                    title: this.$t('invalid_phone_dialog_title'),
                    message: this.$t('invalid_phone_dialog_text'),
                    type: 'is-danger',
                    hasIcon: true,
                    ariaRole: 'alertdialog',
                    ariaModal: true,
                    confirmText: this.$t('ok')
                })
                return false
            }else if(!this.isValidateEmail(this.recipientFull)&&this.isType=='email'){
                this.$buefy.dialog.alert({
                    title: this.$t('invalid_email_dialog_title'),
                    message: this.$t('invalid_email_dialog_text'),
                    type: 'is-danger',
                    hasIcon: true,
                    ariaRole: 'alertdialog',
                    ariaModal: true,
                    confirmText: this.$t('ok')
                })
                return false
            }
            let form={}
            form.recipient = this.recipientFull
            this.getPersonByRecipient(form).then((response) => {
                console.log("response getPersonByRecipient in f")
                console.log(response)
                this.spin=false
                const message = this.isType=='number'?this.$t('duplicated_number_desc'):this.$t('duplicated_email_desc')
                if(response.status.code=='0'){
                    const person = response.content.person
                    console.log("Object.keys(person).length")
                    console.log(Object.keys(person).length)
                    if(Object.keys(person).length>0){
                        this.$buefy.dialog.confirm({
                            title: this.$t('duplicated_record'),
                            message: message,
                            type: 'is-danger',
                            hasIcon: true,
                            cancelText: this.$t('cancel'),
                            confirmText: this.$t('edit_existing_record'),
                            onConfirm: () => this.returnToEditMode(person.sid)
                        })
                    }else{
                        this.recipientIsAvailable = true
                        this.showCheckRecipientButtons=false
                    }
                }
            }).catch(e => {
                console.log('--getPersonByRecipient Error')
                console.log(e)
            })
        },
        returnToEditMode(sid){
            const form = {}
            form.sid = sid
            form.type = this.isType

            this.$emit('returnToUpdateMode',form)
        },  
        addNewRowToConsentList(){
            let row = {
                sid:'NEWLINE',
                status:'ONAY'
            }
            this.concat_records.push(row)
            this.setEditRow(row)
        },
        setRecipientStatus(){
            if(this.isMode!=='update'){
                this.recipientIsAvailable=false
            }
        },
        resetRecipientInput(){
            this.showCheckRecipientButtons=false 
        },
        resetNameInput(){
            this.showUpsertRecipientButtons =false
        },
        getBrand(data){
            if(data){
                if(data.length==0){
                    return ''
                }else{
                    if(this.brands){
                        let brandName = this.brands.find(b => b.brand_code == data.brand_code)
                        if(brandName){
                            return brandName.name
                        }
                        return ""
                    }else{
                        return data.brand_code
                    }
                }
            }else{
                return ''
            }
        },
        getStatusText(data){
            if(data){
                
                return this.$t(data.status)
                
            }else{
                return ''
            }
        },
        getStatusClass(data){
            if(data){
                return this.consentStatusClassDict[data.status]
            }else{
                return ''
            }
        },
        getSourceText(data){
            if(data){
                return this.$t(data.source)
            }else{
                return ''
            }
        },
        getConsentDate(data){
            if(data){
                if(data.consent_date){
                    return this.$moment(data.consent_date.$date).format('L')
                }else{
                    return '-'
                }
            }else{
                return ''
            }
        },
        getConsentTime(data){
            if(data){
                if(data.consent_date){
                    return this.$moment(data.consent_date.$date).format('LTS')
                }else{
                    return '-'
                }
            }else{
                return ''
            }
        },
        getStatusIcon(data){
            let iconSRC = ''
            
            if(data.target_update_iys_record_sid&&data.sync_status=='confirmed'){
                iconSRC = this.disabledIconUrl
            }else if(data.sync_status=='error_on_process'){
                iconSRC = this.transferErrorIconUrl
            }else if(data.sync_status=='error'){
                iconSRC = this.needInfoIconUrl
            }
            else if(data.sync_status == undefined && data.status == undefined && data.type == undefined){
                console.log(data);
                    iconSRC = this.needInfoIconUrl
                }else if(data.sync_status=='awaiting_confirmation'){
                iconSRC = this.transferFailIconUrl
            }else if(data.sync_status=='confirmed'){
                iconSRC = this.disabledIconUrl
            }
            else if(data.hasIysRecord==true){
                iconSRC = this.transferOkIconUrl
            }

            return iconSRC
        },
    
        isRestorableShow(data){
             
            let isRestorable=false

            if(data.sync_status=='error_on_process'&&data.target_update_iys_record_sid){
                isRestorable = true
            }
            
            return isRestorable
        },

        isDeletableShow(data){
             
            let isDeletable=false

            if(data.sync_status!=='confirmed'&&data.hasIysRecord!==true){
                isDeletable = true
            }
            if(data.sync_status=='error_on_process'&&data.target_update_iys_record_sid){
                isDeletable = false
            }
            return isDeletable
        },

        getStatusIconInfo(data){
            let info = {}
            let errorMsg = 'Beklenmeyen bir hata meydana geldi. Lütfen verilerinizi kontrol edip tekrar deneyiniz.' 
            if(data.error_message){
                errorMsg = data.error_message
            }
            
            if(data.target_update_iys_record_sid&&data.sync_status=='confirmed'){
                info.icon = 'check-circle'
                info.type = 'is-primary'
                info.text = "Kayıt güncelleniyor"
            }else if(data.sync_status=='error_on_process'){
                info.icon = 'alert'
                info.type = 'is-primary'
                info.text = "Kaydın e-devlete aktarılması başarısız oldu. <br/> <b>Hata Detayı:</b> "+errorMsg
            }else if(data.sync_status=='error'){
                info.icon = 'alert'
                info.type = 'is-primary'
                info.text = "Kayda ait girilmeyen eksik bilgiler var. Lütfen kontrol ediniz. "
            }
            else if(data.sync_status=='awaiting_confirmation'){
                info.icon = 'alert'
                info.type = 'is-primary'
                info.text = "Kayda ait e-devlet'e aktarılmayan izinler var. Lütfen kontrol ediniz."
            }
            else if(data.sync_status=='confirmed'){
                info.icon = 'check-circle'
                info.type = 'is-primary'
                info.text = "Kayıt gönderiliyor"
            }
            else if(data.hasIysRecord==true){
                info.icon = 'check-circle'
                info.type = 'is-primary'
                info.text = "Kayda ait tüm izinler e-devlet'e aktarılmış"
            }else{
                info = false
            }

            return info
        },

        getRetailer(data){
            const code = data.retailer
            let vendor = this.vendors.find((v)=>{ return v.iys_vendor_code == code })
            if(vendor){
                return vendor.title
            }else{
                return code
            }
        },
        getRetailerAccess(data){
            const list =  data.retailer_access
            if(list){
                return list.map(e => this.vendors.find(v => v.iys_vendor_code==e).title).join(', ')
            }else{
                return ""
            }
        },
        getVendorName(code){
            if(code){
                console.log("code")
                console.log(code)
                let vendorName = this.vendors.find((v)=>{ return v.iys_vendor_code == code }).title
                console.log("vendorName")
                console.log(vendorName)
                if(vendorName){
                    return vendorName
                }else{
                    return ""
                }
            }else{
                return ""
            }
        },
        isValidateEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    },
    watch:{
        isMode(val){
            if(val=='update'){
                this.setUpdateData()
            }
        },
        recipient(val){
            console.log(val)
            console.log(this.isMode)
            console.log(this.isType)
            if(this.isMode=='add'&&this.isType=='number'){
                this.recipientPostfix = val
                console.log("this.recipientPostfix")
                console.log(this.recipientPostfix)
            }
        }
    },
    filters:{
        shortName:function(name,len){
            if(name){
                if ( name.length > len ) {
                    return name.substring(0,len) + '...'
                } else {
                    return name
                }
            }
        }
    }
}
</script>
<style scoped>
    .input-with-buttons{
        position:relative;
    }
    .check-button{
        position:absolute;
        right:35px;
        top:7px;
    }
    .close-button{
        position:absolute;
        right:11px;
        top:7px;
    }
    .custom-table tbody tr td:last-child div:last-child>span.edit-icon{
    opacity: 0;
    }
    .custom-table tbody tr:hover td:last-child div:last-child>span.edit-icon{
    opacity: 1;
    } 
  
</style>


// WEBPACK FOOTER //
// src/components/UpsertConsent.vue